// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"451":"7f13beae","453":"98e65707"}[chunkId] + ".chunk.js";
};